import { render } from "./reservations.vue?vue&type=template&id=636ce522&scoped=true"
import script from "./reservations.vue?vue&type=script&lang=js"
export * from "./reservations.vue?vue&type=script&lang=js"

import "./reservations.vue?vue&type=style&index=0&id=636ce522&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636ce522"]])

export default __exports__